var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFisaDeAparatFaraCp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 40L58 40",
    stroke: "black",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 36,
    width: 29,
    height: 8,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFisaDeAparatFaraCp);
export default __webpack_public_path__ + "static/media/fisa_de_aparat_fara_cp.b67e59b92fd2f6b3095fb90d26f2843b.svg";
export { ForwardRef as ReactComponent };